import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import Gallery from "../../components/Gallery/Gallery";
import BookSpaceForm from "../../components/BookSpaceForm/BookSpaceForm";
import FAQAccordion from "../../components/FAQAccordion/FAQAccordion";

export default function HortonHouse() {
  const galleryItems = [
    {
      title: "Hot Desks",
      description: "Perfect for our independent workers and small teams in an open area. Book below.",
      imageSrc: "/hot-desks.jpeg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Meeting Rooms",
      description: "Suitable for presentations and meetings with your team and clients. Book below.",
      imageSrc: "/IMG_1064.jpeg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Conference Rooms",
      description: "Available for live presentations and meetings on a larger scale. Book below.",
      imageSrc: "/conference.jpeg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Virtual Space",
      description: "Establish a professional presence without the cost of a physical workspace. Book below.",
      imageSrc: "/VirtualSpace.jpg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Office Rental",
      description: "Perfect for established businesses needing privacy. Book below.",
      imageSrc: "/office-rental.jpeg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    },
    {
      title: "Suite Rental",
      description: "Professional private office suites designed to give your business a secure and flexible base. Book below.",
      imageSrc: "/suite.jpeg",
      ctaText: "Contact Us",
      ctaLink: "#book-space-form"
    }
  ];

  return (
    <>
      <HeroAlternative 
        title="Providing Solutions for your professional needs"
        description={`At August Twenty Liberia, we provide the ideal workspace for your needs. Your business deserves a space that works for you, with amenitites you will love and networking opportunities to build your brand.\n\nAugust Twenty Liberia is located at Horton House, Horton Avenue (off Capitol Bypass) Monrovia, Liberia.`}
        imageSrc="/HortonHouse.jpeg"
      />

      <Gallery 
        title="Book A Space"
        subtitle="Find the perfect workspace for your needs"
        items={galleryItems}
      />
      
      <BookSpaceForm id="book-space-form" />

      <FAQAccordion />
    </>
  );
}